import cn from "classnames"

import { Link } from "@/atoms"
import { ExternalLinkOutlined, LinkOutlined } from "@/icons"

import styles from "./ExternalLinkIcon.module.scss"

import type { ExternalLinkIconProps } from "."

export const ExternalLinkIcon = (props: ExternalLinkIconProps) => {
  const { to, href, text, wrap, className, iconPlacement } = props
  const target = href ? props.target || "_blank" : undefined
  const icon = to ? <LinkOutlined /> : <ExternalLinkOutlined />
  const label = text && <span>{text}&nbsp;</span>
  const link = { to, href, target }
  const showLabel = !!label

  if (wrap && showLabel) {
    const start = iconPlacement === "start"

    return (
      <Link
        className={cn(className, {
          [styles.iconStart]: start
        })}
        {...link}
      >
        {start ? icon : label}
        {start ? label : icon}
      </Link>
    )
  }

  return (
    <>
      {showLabel && label}
      <Link {...link}>{icon}</Link>
    </>
  )
}
